import { Card, Stack, Typography } from "@mui/material";
import { HStack } from "@zfp-akademie-a-s/zfp-design";
import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { Dot } from "./Dot";

const Placeholder = Resources.AnalysisDetail.Goals.Timeline.EmptyStatePlaceholder;

type Props = {
  readOnly: boolean;
  onAddGoal: () => void;
};

export const EmptyTimeline = ({ readOnly, onAddGoal }: Props) => {
  const { t } = useResource();

  return (
    <HStack alignItems="center" gap={Spacing.M} mb={Spacing.XXL}>
      <Dot />

      {/* the package card's placeholder variant, for a goal that isn't there yet */}
      <Card variant="dashed" onClick={readOnly ? undefined : onAddGoal} sx={{ maxWidth: 340, cursor: readOnly ? "default" : "pointer" }}>
        <Stack alignItems="flex-start" p={Spacing.L}>
          <Typography variant="body1" color="secondary" fontWeight={600}>
            {t(Placeholder.Title)}
          </Typography>
          <Typography variant="body2" color="secondary">
            {t(Placeholder.Subtitle)}
          </Typography>
        </Stack>
      </Card>
    </HStack>
  );
};
